import * as fromSetup from './setup.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getSetupState = createFeatureSelector<fromSetup.SetupState>('setup');

export const getAnticipatedExpenditures = createSelector(getSetupState, fromSetup.getAnticipatedExpenditures);
export const getSetupSaved = createSelector(getSetupState, fromSetup.getSetupSaved);
